import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData, logout } from 'src/actions/accountActions';
import authService from 'src/services/authService';
import { socketBaseURL } from 'src/constants';
import socketio from 'socket.io-client';
import { SocketContext } from 'src/context/SocketContext';
function Auth({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const { setSocket } = useContext(SocketContext);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });

      authService.handleAuthentication();

      if (authService.isAuthenticated()) {
        const user = await authService.loginInWithToken();

        let newsocket = socketio.connect(socketBaseURL, {
          query: {
            token: localStorage.getItem('accessToken')
          }
        });
        setSocket(newsocket);

        await dispatch(setUserData(user));
      }

      setLoading(false);
    };

    initAuth();

    // eslint-disable-next-line
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
